import { useEffect, useRef, useState } from "react";

const EXIT_MS = 150;

export function useStepTransition<T extends string>(
  target: T,
  order: readonly T[],
) {
  const [shown, setShown] = useState(target);
  const [dir, setDir] = useState<"forward" | "back" | undefined>();
  const [exiting, setExiting] = useState(false);
  const shownRef = useRef(shown);

  useEffect(() => {
    if (target === shownRef.current) {
      setExiting(false);
      return;
    }
    setDir(
      order.indexOf(target) > order.indexOf(shownRef.current)
        ? "forward"
        : "back",
    );
    setExiting(true);
    const id = window.setTimeout(() => {
      shownRef.current = target;
      setShown(target);
      setExiting(false);
    }, EXIT_MS);
    return () => window.clearTimeout(id);
  }, [target, order]);

  return {
    shown,
    stepAttrs: {
      "data-dir": exiting ? undefined : dir,
      "data-exit": exiting ? dir : undefined,
    },
  };
}
